module.exports = __webpack_public_path__ + "img/create@2x.793b2e48.png";